import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { instance } from '~/utils/api/api';
import { useToastError } from '~/utils/useToastError';
import Heading from '~/components/Shared/Heading/Heading';
import Page from '~/components/Shared/Layout/Page/Page';
import FolderIcon from '~/assets/svg/newSvg/folder.svg?react';
import styles from './PhotoStorage.module.scss';

interface IModule {
  key: string;
  name: string;
  photos_count: number;
}

const PhotoStorageModules = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const toastError = useToastError();

  const { data: modules, isLoading } = useQuery({
    queryFn: async () => {
      const { data } = await instance.get('admin/photo-storage/modules');
      return data as IModule[];
    },
    queryKey: ['photo-storage-modules'],
    onError: error => toastError(error),
  });

  return (
    <Page heading={<Heading text={t('photo_storage')} />}>
      <div className={styles.container}>
        <div className={styles.grid}>
          {isLoading
            ? Array.from({ length: 6 }).map((_, i) => (
                <div key={i} className={styles.cardShimmer} style={{ animationDelay: `${i * 0.05}s` }} />
              ))
            : modules?.map(module => (
              <button
                key={module.key}
                type="button"
                className={styles.card}
                onClick={() =>
                  navigate(`/documents/photo-storage/${module.key}`)
                }
              >
                <FolderIcon className={styles.icon} />
                <p className={styles.name}>{module.name}</p>
                <span className={styles.count}>
                  {t('photos_count', { count: module.photos_count })}
                </span>
              </button>
            ))}
        </div>
      </div>
    </Page>
  );
};

export default PhotoStorageModules;
